import React from 'react';
import {  useSelector } from 'react-redux';
import {
    Grid, Button, LinearProgress, Badge, Modal,
    Table, TableBody, TableCell, TableContainer,
    FormControl, Select, InputLabel, MenuItem,
    TableHead, TableRow, Typography, Box, Tooltip, IconButton
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
   
export default function AlertPopup(props) { 
    const { auth, app } = useSelector(state => state);
    const { user, profile } = auth;
    const { app_state, ui_state } = app.current_state;
    let tilename = "On The Books";
    if(ui_state.active_tiles[0] !== "otb"){
        tilename=ui_state.active_tiles[0];
    }
    return (
        <div>
            <Box
                className="alert-popup-wrap"
                sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '500px', 
                    height: 'auto',
                    overflow: "visible !important",
                    zIndex:1400,
                    // bgcolor: '#333',
                    // boxShadow: 10, borderRadius: '5px'
                }}>
                
                <Grid item xs={8.5}>
                    <Box sx={{
                        borderRadius: '8px', height: 'auto', minHeight: '100%', width: '100%',
                        background: '#fff', position: "absolute", padding:"15px", textAlign:"center"
                    }}>
                        <div style={{marginBottom:"10px",color:"red"}}>
                            {/* <WarningAmberIcon sx={{ color: "red" , fontSize:34 }}/> */}
                             <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M44.4001 35.7669L28.0032 7.29125C27.5934 6.59361 27.0085 6.01516 26.3063 5.61324C25.6041 5.21132 24.8091 4.99988 24.0001 4.99988C23.191 4.99988 22.396 5.21132 21.6938 5.61324C20.9916 6.01516 20.4067 6.59361 19.9969 7.29125L3.60006 35.7669C3.20581 36.4417 2.99805 37.2091 2.99805 37.9906C2.99805 38.7721 3.20581 39.5396 3.60006 40.2144C4.00455 40.9162 4.5885 41.4978 5.29199 41.8995C5.99547 42.3012 6.79315 42.5084 7.60318 42.5H40.3969C41.2063 42.5077 42.0032 42.3002 42.706 41.8985C43.4088 41.4969 43.9921 40.9157 44.3963 40.2144C44.7911 39.5399 44.9995 38.7726 45.0002 37.9911C45.0009 37.2096 44.7937 36.442 44.4001 35.7669ZM41.7994 38.7125C41.6565 38.9563 41.4513 39.1578 41.2048 39.2962C40.9584 39.4345 40.6795 39.5049 40.3969 39.5H7.60318C7.32058 39.5049 7.04176 39.4345 6.7953 39.2962C6.54885 39.1578 6.34363 38.9563 6.20068 38.7125C6.0712 38.4933 6.0029 38.2434 6.0029 37.9888C6.0029 37.7342 6.0712 37.4842 6.20068 37.265L22.5976 8.78938C22.7434 8.5467 22.9495 8.34589 23.196 8.20648C23.4424 8.06707 23.7207 7.9938 24.0038 7.9938C24.2869 7.9938 24.5652 8.06707 24.8117 8.20648C25.0581 8.34589 25.2642 8.5467 25.4101 8.78938L41.8069 37.265C41.9353 37.4849 42.0023 37.7352 42.001 37.9898C41.9996 38.2444 41.9301 38.494 41.7994 38.7125ZM22.5001 27.5V20C22.5001 19.6022 22.6581 19.2206 22.9394 18.9393C23.2207 18.658 23.6022 18.5 24.0001 18.5C24.3979 18.5 24.7794 18.658 25.0607 18.9393C25.342 19.2206 25.5001 19.6022 25.5001 20V27.5C25.5001 27.8978 25.342 28.2794 25.0607 28.5607C24.7794 28.842 24.3979 29 24.0001 29C23.6022 29 23.2207 28.842 22.9394 28.5607C22.6581 28.2794 22.5001 27.8978 22.5001 27.5ZM26.2501 34.25C26.2501 34.695 26.1181 35.13 25.8709 35.5C25.6236 35.87 25.2722 36.1584 24.8611 36.3287C24.45 36.499 23.9976 36.5436 23.5611 36.4568C23.1246 36.37 22.7237 36.1557 22.4091 35.841C22.0944 35.5263 21.8801 35.1254 21.7933 34.689C21.7065 34.2525 21.751 33.8001 21.9213 33.389C22.0916 32.9778 22.38 32.6264 22.75 32.3792C23.12 32.132 23.5551 32 24.0001 32C24.5968 32 25.1691 32.2371 25.591 32.659C26.013 33.081 26.2501 33.6533 26.2501 34.25Z" fill="#FA5252"/>
                            </svg>

                        </div>

                        <div style={{marginBottom:"10px", fontFamily: "SFUI Regular"}}>
                            We haven't received {tilename} Data as of {props.propertyAsOf}
                        </div>
                        <div style={{marginBottom:"10px", fontFamily: "SFUI Regular"}} >Latest Data Received as of {props.apiAsOfDate} </div>
                        <Button variant="contained" sx={{fontFamily: "SFUI Regular", padding:"3px", marginLeft:"83%",
                        backgroundColor:"#00415F", color:"white"}}
                          onClick={props.handleClose}>Ok</Button>
                    </Box>
                </Grid>
                </Box>
        </div>
    )
}


